module.exports = __webpack_public_path__ + "static/media/event.313f56fe.png";